import { ServiceNotificationItem, ServiceNotificationType, ServiceNotificationState } from './service-notifications.models';


export const MOCK_NOTIFICATIONS: ServiceNotificationItem[] = [
  {
    id: '1',
    key: 'external',
    copy1: 'External Action Required',
    copy2: 'Link an external account',
    copy3: 'We need more info to complete your profile.',
    type: ServiceNotificationType.ALERT_ACTION,
    route: 'external',
    read: false,
    state: ServiceNotificationState.ACTION,
    createTs: new Date().toISOString()
  },
  {
    id: '2',
    key: 'savings',
    copy1: 'Savings Reminder',
    copy2: 'Check your auto-save setup',
    copy3: 'Let’s make sure you’re putting money aside.',
    type: ServiceNotificationType.INFO,
    route: 'savings',
    read: false,
    state: ServiceNotificationState.PENDING,
    createTs: new Date().toISOString()
  },
  {
    id: '3',
    key: 'survey',
    copy1: 'Feedback Request',
    copy2: 'Tell us what you think',
    copy3: 'We’re always looking to improve.',
    type: ServiceNotificationType.INFO_ACTION,
    route: 'survey',
    read: true,
    state: ServiceNotificationState.COMPLETE,
    createTs: new Date().toISOString()
  },
  {
    id: '4',
    key: 'external',
    copy1: 'External Action Required',
    copy2: 'Link an external account',
    copy3: 'We need more info to complete your profile.',
    type: ServiceNotificationType.URGENT,
    route: 'savings',
    read: true,
    state: ServiceNotificationState.COMPLETE,
    createTs: new Date().toISOString()
  },
  {
    id: '5',
    copy1: 'Feedback Request',
    copy2: 'Tell us what you think',
    copy3: 'We’re always looking to improve.',
    type: ServiceNotificationType.URGENT,
    route: 'survey',
    read: true,
    state: ServiceNotificationState.COMPLETE,
    createTs: new Date().toISOString()
  }
];
